var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33268 4.66667C5.96754 4.66667 3.99935 6.63486 3.99935 9C3.99935 11.3651 5.96754 13.3333 8.33268 13.3333C10.6978 13.3333 12.666 11.3651 12.666 9C12.666 8.63181 12.9645 8.33333 13.3327 8.33333C13.7009 8.33333 13.9993 8.63181 13.9993 9C13.9993 12.1015 11.4342 14.6667 8.33268 14.6667C5.23116 14.6667 2.66602 12.1015 2.66602 9C2.66602 5.89848 5.23116 3.33333 8.33268 3.33333H10.9993C11.3675 3.33333 11.666 3.63181 11.666 4C11.666 4.36819 11.3675 4.66667 10.9993 4.66667H8.33268Z",
    fill: "#00AEEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52794 1.5286C8.78829 1.26825 9.2104 1.26825 9.47075 1.5286L11.4708 3.5286C11.7311 3.78895 11.7311 4.21106 11.4708 4.4714L9.47075 6.4714C9.2104 6.73175 8.78829 6.73175 8.52794 6.4714C8.2676 6.21106 8.2676 5.78895 8.52794 5.5286L10.0565 4L8.52794 2.4714C8.2676 2.21106 8.2676 1.78895 8.52794 1.5286Z",
    fill: "#00AEEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refreshIcon.a2e77fb11f569c0f7339c85b243385d0.svg";
export { ForwardRef as ReactComponent };